<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container>
  <ng-container *ngIf="ready">
    <div class="butonera">
      <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
      </button>
    </div>

  </ng-container>

  <ng-container>
    <div class="tableTitle">
      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="true" [hasButton]="true"
        [actionsTemplate]="actionsButtons" [hasHeaderActions]="true" [headerActionsTemplate]="headerActionsButtons"
        [hasMonthFilter]="true" [showTotals]="true" [showTotalsHasOptionToPay]="false" [textPaided]="'Cobrado'"
        [textUnpaid]="'No cobrado'" (preInvoiceNumberClick)="onPreInvoiceNumberClick($event)"
        (preInvoiceIssuerClick)="onPreInvoiceIssuerClick($event)">
      </app-table>
    </div>
  </ng-container>

  <ng-container *ngIf="empty">
    <div class="text-center">
      <img src="assets/icons/albaran.svg" class="invoiceImage">
      <p style="color: #9e9e9e">No tiene ningún albarán, presione + para crear uno.</p>
    </div>
  </ng-container>



  <!--acciones buttons header-->
  <ng-template #headerActionsButtons let-selected="selected">
    <ul class="custom-class">
      <li (click)="export(selected)">
        <a>Convertir en factura</a>
      </li>
      <li (click)="bookDeliveryNotes(selected)">
        <a>Exportar a Excel</a>
      </li>
      <li (click)="bookDeliveryNotesProducts(selected)">
        <a>Exportar Albaran-Producto</a>
      </li>
    </ul>
  </ng-template>

  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
      <ul class="custom-class">
        <li (click)="pdf(uid)">
          <a>
            <mat-icon>dvr</mat-icon>PDF
          </a>
        </li>
        <ng-container *ngIf="row.sendedMail != null">
          <li (click)="pdfMail(uid)">
            <a>
              <mat-icon>send</mat-icon>Enviada {{row.sendedMail | date}}
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="row.sendedMail == null">
          <li (click)="pdfMail(uid)">
            <a>
              <mat-icon>send</mat-icon>Enviar PDF
            </a>
          </li>
        </ng-container>
        <li (click)="duplicate(uid)">
          <a>
            <mat-icon>content_copy</mat-icon>Duplicar albarán
          </a>
        </li>
        <ng-container *ngIf="row.convertedToInvoice == null">
          <li (click)="edit(row.uid)">
            <a>
              <mat-icon>create</mat-icon>Editar
            </a>
          </li>
          <li (click)="delete(row.uid)">
            <a>
              <mat-icon>warning</mat-icon>Borrar
            </a>
          </li>
          <li (click)="convertToInvoice(row.uid)">
            <a><mat-icon>launch</mat-icon>Convertir en factura</a>
          </li>
        </ng-container>

      </ul>
    </ng-container>
  </ng-template>
</ng-container>
